import React from 'react';
import Popover from '../Popover';
import SearchSelectionListInner from './components/SearchSelectionListInner';

const SearchSelectionList = ({
  activatorElement,
  items,
  onItemSelected,
  value,
  isLoading,
} = {}) => (
  <Popover
    activatorElement={activatorElement}
    noPadding
    childToggle={{ onItemSelected: () => (true) }}
  >
    <SearchSelectionListInner {...{
      activatorElement,
      items,
      onItemSelected,
      value,
      isLoading,
    }}
    />
  </Popover>
);

SearchSelectionList.defaultProps = {
  items: [],
  onItemSelected: null,
  value: [],
};

export default SearchSelectionList;
